<template>
  <f7-page>
    <f7-navbar
    no-shadow
    :title="$t('404.notFound')"
    back-link
    :back-link-show-text="false"
    ></f7-navbar>
    <AppLayout>
      <template #main>

        <f7-block strong>
          <p>{{ $t("404.sorry") }}</p>
          <p>{{ $t("404.requestedContentNotFound") }}</p>
        </f7-block>
      </template>
    </AppLayout>
  </f7-page>
</template>
<script setup>
import _ from "lodash";
import AppLayout from "@/components/common/AppLayout.vue";
defineProps({
  f7route: Object,
  f7router: Object,
});
</script>
